import { getChildNode } from '../dom/node';
import { isParagraphElement } from '../dom/paragraph';
import { isSelectionCollapsed, isSelectionPresent, SelectionLike, updateSelection } from '../selection';

export function normalizeSelection(element: Element, selection: SelectionLike): SelectionLike {
  let normalizedSelection = selection;

  // If the cursor is placed immediately before a paragraph, move it inside so that typing and operations work
  // properly. This is especially important after the user used backspace to remove <div><br></div> from an
  // empty editor, and we added it back during DOM normalization, and need to put the cursor back inside as
  // well.
  if (isSelectionCollapsed(selection) && selection.focusNode === element) {
    const nodeAfterCursor = getChildNode(element, selection.focusOffset);

    if (isParagraphElement(nodeAfterCursor)) {
      normalizedSelection = {
        anchorNode: nodeAfterCursor,
        anchorOffset: 0,
        focusNode: nodeAfterCursor,
        focusOffset: 0,
      };
    }
  }

  return normalizedSelection;
}

export function normalizeSelectionInElement(element: Element): void {
  const selection = element.ownerDocument && element.ownerDocument.getSelection();
  if (!isSelectionPresent(selection)) {
    return;
  }

  updateSelection(selection, normalizeSelection(element, selection));
}
